import React from 'react';
import _ from 'lodash';
import { PropTypes } from 'prop-types';

const Filter = ({
    name,
    label,
    link,
    options,
    activeOptions,
    onClickOption
}) => {
    if (options.length === 0) {
        return null;
    }

    const opt = options.map(o => {
        let className = 'filter-option-add';
        if (_.find(activeOptions, a => a.slug === o.slug)) {
            className += ' active';
        }

        return (
            <li
                key={o.slug}
                className="filter-option"
                >
                <a
                    href={o.link}
                    rel="nofollow"
                    tabIndex="0"
                    className={className}
                    aria-label={`Add filter: ${o.name}`}
                    dangerouslySetInnerHTML={{ __html: o.name }}
                    onClick={e => {
                        e.preventDefault();
                        onClickOption(name, o);
                    }}
                />
            </li>
        );
    });

    let classList = ['filter', name];

    return (
        <div className={classList.join(' ')}>
            <h3 className="filter-name">
                <a
                    href={link}
                    rel="nofollow"
                    tabIndex="0"
                    className="filter-name-link"
                    aria-expanded="false"
                    aria-controls={`${name}-options`}
                    aria-label={`Show ${label} filters`}
                >
                    {label}
                    <svg aria-hidden="true" width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1683 808l-742 741q-19 19-45 19t-45-19L109 808q-19-19-19-45.5t19-45.5l166-165q19-19 45-19t45 19l531 531 531-531q19-19 45-19t45 19l166 165q19 19 19 45.5t-19 45.5z" fill="#C12736" /></svg>
                </a>
            </h3>
            <ul id={`${name}-options`} className="filter-options">{opt}</ul>
        </div>
    );
};

Filter.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    link: PropTypes.string,
    options: PropTypes.array,
    activeOptions: PropTypes.array,
    onClickOption: PropTypes.func.isRequired
};

export default Filter;



// WEBPACK FOOTER //
// ./wp-content/themes/gwy/assets/scripts/source/vpm/post-grid/components/filter.js